import { useOfferContext } from "./useOfferContext";
import { TTip } from "@data-types/offer/event-row/EventRow";
import { constants } from "@gp/offer";

export default function useMapOfferIntoTipsForRender(
	tips: string[] | undefined,
	offerKeyId: string | undefined
) {
	const offerStore = useOfferContext();

	const tipsForRender: TTip[] = [];

	if (tips == null || offerKeyId == null) {
		return null;
	}

	const offerMap = offerStore.keyOffersMap.get(offerKeyId);

	if (offerMap == null || offerMap.size === 0) {
		return null;
	}

	const offers = Array.from(offerMap.values());

	if (offers == null || offerMap.size === 0) {
		return null;
	}

	for (let i = 0; i < Math.max(tips?.length, offers.length); i++) {
		const currentTip = i >= tips.length ? null : tips[i];

		if (currentTip == null) {
			if (offers[i] != null) {
				tipsForRender.push({
					isMargin: false,
					tip: offers[i],
				});
				continue;
			}

			// when we reach first null offer, we know everything else behind is null. Thus we break the loop
			break;
		}

		if (currentTip === constants.emptyPlaceholder) {
			continue;
		}

		if ([constants.gamenrPlaceholder].includes(currentTip)) {
			if (offers[0].specifier == null) {
				console.error("Expected offers with specifiers, got null");
				continue;
			}

			tipsForRender.push({
				isResult: true,
				result: offers[0].specifier[currentTip] + ". set",
			});
			continue;
		}

		if (
			[
				constants.setnrPlaceholder,
				constants.framenrPlaceholder,
				constants.marginPlaceholder,
			].includes(currentTip)
		) {
			if (offers[0].specifier == null) {
				console.error("Expected offers with specifiers, got null");
				continue;
			}

			tipsForRender.push({
				key: currentTip + "-" + i,
				isMargin: true,
				margin: offerStore.formatSpecifier(offers[0].specifier),
				tip: null,
			});
			continue;
		}

		if (currentTip.trim() === "") {
			tipsForRender.push({
				key: currentTip + "-" + i,
				isMargin: false,
				tip: null,
			});
			continue;
		}

		const tipOffer = offers.find(
			(o) => o.tip.toLowerCase() == currentTip.toLowerCase()
		);

		if (tipOffer == null) {
			tipsForRender.push({
				key: currentTip + "-" + i,
				isMargin: false,
				tip: {
					displayTip: currentTip,
				},
			});
			continue;
		}

		tipsForRender.push({
			isMargin: false,
			tip: tipOffer,
		});
	}

	return tipsForRender;
}
